import { Box, Button, LinearProgress, Typography } from "@material-ui/core";
import DragHandleIcon from "@material-ui/icons/DragHandle";
import React from "react";
import Modal from "src/shared/components/Modal";
import SeasonsList from "../../../season-list/SeasonsList";
import {
  CLOSE_EDIT_SEASONS_MODAL_BUTTON_LABEL,
  EDIT_SEASONS_MODAL_HEADER,
  MOVE_DRAG_HANDLE_PREFIX,
  MOVE_DRAG_HANDLE_SUFFIX,
  SEASONS_FETCH_FAILURE,
} from "./constants";
import { IEditSeasonsModalProps } from "./types";

export const EditSeasonsModal = ({
  isOpen,
  onClose,
  loadingSeasonsResponse,
  seasons,
  defaultSeasons,
  schoolId,
  loadSeasons,
  setSeason,
  seasonsChange,
}: IEditSeasonsModalProps) => {
  const isLoadingSeasons = loadingSeasonsResponse !== undefined;
  const hasSeasons = seasons !== undefined;

  return (
    <Modal open={isOpen} closeModal={onClose}>
      <Box
        display="flex"
        flexDirection="column"
        height="100%"
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="h4">{EDIT_SEASONS_MODAL_HEADER}</Typography>
          <Box
            display="flex"
            flexDirection="column"
            gridGap="1rem"
            marginTop="1.5rem"
          >
            <Typography variant="body2">
              <Box display="flex">
                {MOVE_DRAG_HANDLE_PREFIX}&nbsp;
                <DragHandleIcon />
                &nbsp;
                {MOVE_DRAG_HANDLE_SUFFIX}
              </Box>
            </Typography>
            <Box>
              {isLoadingSeasons && <LinearProgress variant="query" />}
              {!isLoadingSeasons && hasSeasons && (
                <SeasonsList
                  defaultSeasons={defaultSeasons}
                  schoolId={schoolId}
                  seasons={seasons}
                  loadingSeasonsResponse={loadingSeasonsResponse}
                  loadSeasons={loadSeasons}
                  setSeason={setSeason}
                  seasonsChange={seasonsChange}
                />
              )}
              {!isLoadingSeasons && !hasSeasons && (
                <Typography variant="body2">{SEASONS_FETCH_FAILURE}</Typography>
              )}
            </Box>
          </Box>
        </Box>
        <Box>
          <Button variant="contained" color="secondary" onClick={onClose}>
            {CLOSE_EDIT_SEASONS_MODAL_BUTTON_LABEL}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/components/seasons-editor/components/edit-seasons-modal/EditSeasonsModal.tsx